import TestSeriesDTO from "../../../../api/models/TestSeriesDTO";
import ActionValue from "../../../../api/models/test-series/ActionValue";

interface TmbParameterAction {
  productActionTmbIds: number[];
  substrateActionTmbIds: number[];
  buildingActionTmbIds: number[];
  treatmentActionTmbIds: number[];
}

const extractTmbIds = (actionValues: ActionValue[] | undefined): number[] => {
  const tmbIds: number[] = [];
  if (actionValues) {
    actionValues.forEach((actionValue) => {
      if (actionValue.action && actionValue.action.tmbId) {
        tmbIds.push(actionValue.action.tmbId);
      }
    });
  }
  return tmbIds;
};

const createTmbActionIdObject = (testSeries: TestSeriesDTO): TmbParameterAction => {
  let tmbIdsFromActionValues = [];

  const tmbIdsForProducts: Set<number> = new Set();
  const tmbIdsForSubstrates: Set<number> = new Set();
  const tmbIdsForBuildingActions: Set<number> = new Set();
  const tmbIdsForTreatments: Set<number> = new Set();

  testSeries.productSection.productActionFlows.forEach((productActionFlow) => {
    tmbIdsFromActionValues = extractTmbIds(productActionFlow.actionFlow?.actionValues);
    tmbIdsFromActionValues.forEach((tmbId) => {
      tmbIdsForProducts.add(tmbId);
    });
  });

  testSeries.substrateSections.forEach((section) => {
    section.substrateActionFlows.forEach((substrateActionFlow) => {
      tmbIdsFromActionValues = extractTmbIds(substrateActionFlow.actionFlow?.actionValues);
      tmbIdsFromActionValues.forEach((tmbId) => {
        tmbIdsForSubstrates.add(tmbId);
      });
    });
  });

  // building actions for specimen
  testSeries.specimenSection.buildingActions.forEach((buildingAction) => {
    tmbIdsFromActionValues = extractTmbIds(buildingAction.actionValues);
    tmbIdsFromActionValues.forEach((tmbId) => {
      tmbIdsForBuildingActions.add(tmbId);
    });
  });

  tmbIdsFromActionValues = extractTmbIds(testSeries.specimenSection.buildingActionsOnAllSpecimen?.actionValues);
  tmbIdsFromActionValues.forEach((tmbId) => {
    tmbIdsForBuildingActions.add(tmbId);
  });

  // treatment actions for specimen
  testSeries.specimenSection.treatments.forEach((treatmentAction) => {
    tmbIdsFromActionValues = extractTmbIds(treatmentAction.actionValues);
    tmbIdsFromActionValues.forEach((tmbId) => {
      tmbIdsForTreatments.add(tmbId);
    });
  });

  tmbIdsFromActionValues = extractTmbIds(testSeries.specimenSection.treatmentOnAllSpecimen?.actionValues);
  tmbIdsFromActionValues.forEach((tmbId) => {
    tmbIdsForTreatments.add(tmbId);
  });

  return {
    productActionTmbIds: Array.from(tmbIdsForProducts),
    substrateActionTmbIds: Array.from(tmbIdsForSubstrates),
    buildingActionTmbIds: Array.from(tmbIdsForBuildingActions),
    treatmentActionTmbIds: Array.from(tmbIdsForTreatments),
  };
};

export default createTmbActionIdObject;
